import { Filters } from '../../../model/Filters'

const all = ['recipientSuggestions']
const search = (filters: Filters) => [...all, 'search', filters]

export const recipientSuggestionsKeys = {
  all,
  search,
}
